import { render, staticRenderFns } from "./listing-facts-edit.vue?vue&type=template&id=61ed8cc6&scoped=true"
import script from "./listing-facts-edit.vue?vue&type=script&lang=js"
export * from "./listing-facts-edit.vue?vue&type=script&lang=js"
import style0 from "./listing-facts-edit.vue?vue&type=style&index=0&id=61ed8cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed8cc6",
  null
  
)

export default component.exports